import Control from "ol/control/Control";
import { eraTrans, mapTrans } from "../translations";
export default class YearMapControls extends Control {
    years;
    yearSelect;
    buttonPrev;
    buttonNext;
    settings;
    constructor(settings) {
        const years = [
            ...settings.getSupportedSeaYears(),
            new Date().getFullYear(),
        ];
        const buttonPrev = createButton("<", mapTrans.yearControls.prevYear);
        const buttonNext = createButton(">", mapTrans.yearControls.nextYear);
        const yearSelect = createYearSelectElement(years);
        yearSelect.value = settings.getYear().toString();
        const element = document.createElement("div");
        element.className = "year-buttons";
        element.appendChild(buttonPrev);
        element.appendChild(yearSelect);
        element.appendChild(buttonNext);
        super({ element });
        this.years = years;
        this.yearSelect = yearSelect;
        this.buttonPrev = buttonPrev;
        this.buttonNext = buttonNext;
        this.settings = settings;
        buttonPrev.addEventListener("click", () => {
            this.prevYear();
        });
        buttonNext.addEventListener("click", () => {
            this.nextYear();
        });
        yearSelect.addEventListener("change", (event) => {
            const selectedValue = event.target.value;
            this.updateYear(parseInt(selectedValue));
        });
        this.updateButtonsStatus();
    }
    hasPrevYear() {
        const prevYearIndex = this.years.indexOf(this.settings.getYear()) - 1;
        return prevYearIndex >= 0;
    }
    hasNextYear() {
        const nextYearIndex = this.years.indexOf(this.settings.getYear()) + 1;
        return nextYearIndex < this.years.length;
    }
    updateYear(year) {
        this.yearSelect.value = year.toString();
        this.settings.setYear(year);
        this.updateButtonsStatus();
    }
    updateButtonsStatus() {
        this.buttonPrev.disabled = !this.hasPrevYear();
        this.buttonNext.disabled = !this.hasNextYear();
    }
    prevYear() {
        const prevYearIndex = this.years.indexOf(this.settings.getYear()) - 1;
        if (this.hasPrevYear()) {
            this.updateYear(this.years[prevYearIndex]);
        }
    }
    nextYear() {
        const nextYearIndex = this.years.indexOf(this.settings.getYear()) + 1;
        if (this.hasNextYear()) {
            this.updateYear(this.years[nextYearIndex]);
        }
    }
    updateSelectYears() {
        this.yearSelect.innerHTML = "";
        this.yearSelect.append(...getSelectOptions(this.years));
    }
}
const createButton = (label, title) => {
    const button = document.createElement("button");
    button.className = "btn btn-info btn-sm";
    button.title = title;
    button.innerHTML = label;
    return button;
};
const createYearSelectElement = (years) => {
    const select = document.createElement("select");
    select.title = mapTrans.yearControls.selectTitle;
    select.className = "form-select form-select-sm";
    select.append(...getSelectOptions(years));
    return select;
};
const getSelectOptions = (years) => {
    return years.map((year) => {
        const option = document.createElement("option");
        option.value = year.toString();
        option.text = (() => {
            if (year >= 0) {
                return `${year} ${eraTrans.ce}`;
            }
            else {
                return `${-year} ${eraTrans.bce}`;
            }
        })();
        return option;
    });
};
